export default (opts = {}) => {
    const component = {
        model: {
            defaults: {
              tagname:'div', 
              name: "Div",
              attributes: { class: 'w-100 gap-40 d-flex  d-sm-column wrap' },
              components: [
               {
                type:'cardDifferences3',
               },
               {
                type:'cardDifferences3',
               },
               {
                type:'cardDifferences3',
               },
               {
                type:'cardDifferences3',
               },
               {
                type:'cardDifferences3',
               },
               {
                type:'cardDifferences3',
               },
               {
                type:'cardDifferences3',
               },
               {
                type:'cardDifferences3',
               },
              ],
              styles: `
               .d-flex{
                display:flex; 
                flex-direction:row; 
               }
               .gap-40{
                gap:40px;
               }
               .w-100{
                width:100%; 
               }
               .wrap{
                flex-wrap: wrap; 
               }
               @media (max-width:992px){
                .d-sm-column{
                  flex-direction: column !important; 
                }
              }
            `,
             },
          },
          view: {
      
          },
};
  return component; 
};